import { render } from "./BusyLeads.vue?vue&type=template&id=9468cf22&scoped=true"
import script from "./BusyLeads.vue?vue&type=script&lang=js"
export * from "./BusyLeads.vue?vue&type=script&lang=js"

import "./BusyLeads.vue?vue&type=style&index=0&id=9468cf22&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9468cf22"]])

export default __exports__